import { render, staticRenderFns } from "./ClientWezideeDialog.vue?vue&type=template&id=621b70be&scoped=true"
import script from "./ClientWezideeDialog.vue?vue&type=script&lang=js"
export * from "./ClientWezideeDialog.vue?vue&type=script&lang=js"
import style0 from "./ClientWezideeDialog.vue?vue&type=style&index=0&id=621b70be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b70be",
  null
  
)

export default component.exports